import { useCallback, useEffect, useState } from "react";
export function useIdle(timeoutSeconds) {
    const [idle, setIdle] = useState(false);
    let timer = NaN;
    const handleIdle = useCallback(() => {
        setIdle(true);
    }, []);
    const handleUserInteraction = useCallback(() => {
        // clear previous timeout on user interaction
        window.clearTimeout(timer);
        // set our status flag
        setIdle(false);
        // start new timeout
        timer = window.setInterval(handleIdle, 1000 * timeoutSeconds);
    }, [handleIdle, timeoutSeconds]);
    useEffect(() => {
        timer = window.setInterval(handleIdle, 1000 * timeoutSeconds);
        window.addEventListener("click", handleUserInteraction, true);
        window.addEventListener("scroll", handleUserInteraction, true);
        return () => {
            window.clearTimeout(timer);
            window.removeEventListener("click", handleUserInteraction, true);
            window.removeEventListener("scroll", handleUserInteraction, true);
        };
    }, [handleIdle, timeoutSeconds]);
    return idle;
}
//# sourceMappingURL=idle.js.map